import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the AnalysesHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'analyses-header',
  templateUrl: 'analyses-header.html',
  styleUrls: ['./analyses-header.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class AnalysesHeaderComponent {

  text: string;

  constructor(private translateService: TranslateService) {
    this.text = this.translateService.instant('MENU.MY_ANALYSES');
  }

  ngOnInit() {
    this.translateService.get(['MENU']).subscribe(translations => {
        this.text = translations.MENU.MY_ANALYSES;
    })
  }
}
